'use client';

import { usePathname } from 'next/navigation';

/**
 * Some marketing routes ship their own bespoke Selenos chrome (nav, footer,
 * chat widget): the homepage and the public qualified-lead spec page. This
 * gate stops the generic shared marketing chrome (SiteHeader / SiteFooter /
 * sticky CTA / exit popup / generic chat widget) from rendering on those
 * routes only; every other marketing route keeps it.
 *
 * Scoped, reversible: not a rebrand of the shared chrome (that comes later,
 * once the landing language is validated and applied elsewhere).
 */
const BESPOKE_SELENOS_PATHS = ['/', '/qualified-lead-spec'];

export function HideOnSelenosSurfaces({ children }: React.PropsWithChildren) {
  const pathname = usePathname();

  // usePathname may include the locale prefix (e.g. /de/qualified-lead-spec).
  const withoutLocale =
    pathname.replace(/^\/[a-z]{2}(-[A-Z]{2})?(?=\/|$)/, '') || '/';

  if (BESPOKE_SELENOS_PATHS.includes(withoutLocale)) return null;

  return <>{children}</>;
}
